import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChooseFacilityComponent } from './choose-facility/choose-facility.component';
import { FiledashboardComponent } from './filedashboard/filedashboard.component';
import { AuthGuard } from './shared/guards/auth.service';

const routes: Routes = [
  {
    path: 'filedashboard',
    component: FiledashboardComponent, canActivate: [AuthGuard],
  },
  {
    path: 'choosesite',
    component: ChooseFacilityComponent, canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
